<template>
  <v-row justify="center">
    <!-- <v-btn color="primary" dark @click.stop="dialog = true">
      Open Dialog
    </v-btn> -->

    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="justify-center text-white warning">
          {{ dialogTitle }}
        </v-card-title>

        <v-card-text class="mt-5">
          {{ dialogText }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" @click="dialog = false">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      dialogTitle: "",
      dialogText: "",
      dialog: false
    };
  }
};
</script>
